/* eslint-disable react/prop-types */
import React, { Component } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Redirect, Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import Loader from "components/Loader";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import AddAlert from "@material-ui/icons/AddAlert";
class UpdateChapter extends Component {
  state = {
    name: "",
    tags: [],
    redirect: false,
    initialTags: [],
    id: "",
    show: false,
    loading: false
  };

  componentDidMount() {
    const chapterData = this.props.location.state.chapterData;
    this.setState({
      name: chapterData.name
    });
  }
  handleSubmit = e => {
    this.setState({ loading: true });
    e.preventDefault();
    const subjectId = this.props.location.state.subject_id;
    // console.log(subjectId);
    const chapterId = this.props.location.state.chapterData.id;
    const payload = {
      name: this.state.name,
      chapterId: chapterId
    };
    axios
      .post(
        "https://core.akclasses.in/api/subjects/" +
          subjectId +
          "/chapters/edit",
        payload
      )
      .then(() => {
        // console.log(res);
        this.setState({
          loading: false,
          show: true
        });
        setTimeout(() => {
          this.setState({
            redirect: true
          });
        }, 1000);
      })
      .catch(() => {
        // console.log(error);
      });
  };
  handleInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin/chapters"} />;
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.show ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Chapter Updated Successfully!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Update Chapter</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Name"
                          id="float"
                          inputProps={{
                            required: true,
                            value: this.state.name,
                            onChange: e =>
                              this.setState({ name: e.target.value })
                          }}
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <Button className="" color="warning" type="submit">
                          {this.state.loading ? <Loader /> : "Update Chapter"}
                        </Button>
                        <Link
                          to={{
                            pathname: "/admin/chapters"
                          }}
                        >
                          <Button className="btn-round" color="danger">
                            Cancel
                          </Button>
                        </Link>
                      </GridItem>
                    </GridContainer>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default UpdateChapter;
